import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';

import { readFile } from '../../../lib/file';
import { stackupLayerPropType } from '../../../lib/shapes';
import { FILE_EXTENSION } from '../../../constants/globals';

export class ImportingDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleImport = this.handleImport.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.restore = this.restore.bind(this);
    this.state = {
      files: [],
      error: undefined
    }
  }

  restore({ body }) {
    const { restoreStackup, restoreCalculations } = this.props;
    const { stackup, calculations } = body;
    restoreStackup(stackup);
    restoreCalculations(calculations);
  }

  handleImport() {
    const { history } = this.props;
    const { files } = this.state;
    this.setState({ files: [] });

    readFile(files[0])
    .then(data => {
      this.restore(data);
      history.push({
        pathname: '/refresh', 
        state: { to: '/app' }
      });
    })
    .catch(error => {
      this.setState({ error });
    });
  }

  handleChange(prop) {
    const that = this;

    return event => {
      that.setState({ [prop]: event.target.value });
    };
  }

  handleFileChange(prop) {
    const that = this;

    return event => {
      that.setState({ [prop]: event.target.files });
    };
  }

  render() {
    const { fullScreen, open, handleClose, stackup } = this.props;
    const { layers } = stackup;
    const { files, error } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Import downloaded Stackup Configuration
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Choose a file to import
          </DialogContentText>
          <FormControl fullWidth>
            <InputLabel htmlFor="file">Select a File</InputLabel>
            <Input
              id="file"
              autoFocus
              autoComplete="off"
              margin="dense"
              type="file"
              onChange={this.handleFileChange('files')}
              inputProps={{
                accept: FILE_EXTENSION
              }}
            />
          </FormControl>
          {layers.length > 0 ? (
            <div>
              <DialogContentText>
                Warning!! Current stackup will be lost.
              </DialogContentText>
              <DialogContentText>
                {error ? error.toString() : null}
              </DialogContentText>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Close 
          </Button>
          <Button
            onClick={this.handleImport}
            color="primary"
            autoFocus
            variant="raised"
            disabled={files.length === 0}
          >
            Import 
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ImportingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  restoreStackup: PropTypes.func.isRequired,
  restoreCalculations: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  stackup: PropTypes.shape({
    name: PropTypes.string,
    partNumber: PropTypes.string,
    type: PropTypes.string,
    layers: PropTypes.arrayOf(PropTypes.shape(stackupLayerPropType))
  }).isRequired,
};

export default withMobileDialog()(ImportingDialog);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/ImportingDialog/ImportingDialog.jsx